import React, { useState } from 'react'
import ReactLinesEllipsis from 'react-lines-ellipsis'
import { EIconSize, Icon } from '@frontend/pole-ui/lib/components/Icon'
import { ShevronDownIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronDownIcon'
import { ShevronUpIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShevronUpIcon'
import classNames from 'classnames'
import { messages } from './messages'
import type { TTruncatedTextProps } from './types'
import './styles.scss'

export const TruncatedText = ({
  children,
  maxLines,
  className,
  withIcon,
  collapseButtonText = messages.collapse,
  expandButtonText = messages.expand,
}: TTruncatedTextProps) => {
  const [shouldToShowToggle, setNeedToShowToggle] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  const handleClick = () => {
    setIsExpanded(state => !state)
  }

  const handleReflow = (options: { clamped: boolean; text: string }) => {
    if (!isExpanded) {
      setNeedToShowToggle(options.clamped)
    }
  }

  return (
    <div className={classNames(className, 'truncatedText')}>
      <ReactLinesEllipsis maxLine={isExpanded ? Infinity : maxLines} text={children} onReflow={handleReflow} />
      {shouldToShowToggle && (
        <button className="truncatedText__toggle" onClick={handleClick}>
          <span className="truncatedText__toggleText">{isExpanded ? collapseButtonText : expandButtonText}</span>
          {withIcon && <Icon component={isExpanded ? <ShevronUpIcon /> : <ShevronDownIcon />} size={EIconSize.XS} />}
        </button>
      )}
    </div>
  )
}
